export default {"src":"/_next/static/media/ZFOX.188be394.svg","height":18,"width":18};